module.exports = "//static.hsappstatic.net/salesImages/static-1.403/product-features/salesdeals.png"